module.exports = ":root{--lui-logo-color:var(--lui-text-color);--lui-logo-missing-piece-color:var(--lui-accent-light-color)}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-logo/theme/lui-logo.global.scss
// module id = 236
// module chunks = 0 1 10